// extracted by mini-css-extract-plugin
module.exports = {"MainInvoiceContainer":"PaymentPage_MainInvoiceContainer__cenoI","TotalFeeBox":"PaymentPage_TotalFeeBox__3Kimb"};